export const THEMES = {
  classic:  { label: 'Dawal Classic', navBg: '#2563eb', navBorder: '#1d4ed8', appBg: 'linear-gradient(135deg, #f0f4ff 0%, #ffffff 50%, #fef3f2 100%)', solid: '#f4f7ff' },
  light:    { label: 'Clean Slate',   navBg: '#475569', navBorder: '#334155', appBg: '#f8fafc', solid: '#f8fafc' },
  ocean:    { label: 'Ocean Blue',    navBg: '#0e7490', navBorder: '#155e75', appBg: 'linear-gradient(135deg, #ecfeff 0%, #ffffff 55%, #e0f2fe 100%)', solid: '#f0fdff' },
  forest:   { label: 'Forest Green',  navBg: '#15803d', navBorder: '#166534', appBg: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 55%, #dcfce7 100%)', solid: '#f2fdf5' },
  midnight: { label: 'Midnight',      navBg: '#0f172a', navBorder: '#1e293b', appBg: 'linear-gradient(135deg, #e2e8f0 0%, #f8fafc 60%, #cbd5e1 100%)', solid: '#eef2f7' },
  sunset:   { label: 'Sunset',        navBg: '#ea580c', navBorder: '#c2410c', appBg: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #ffedd5 100%)', solid: '#fff8f0' },
};

export function themeVarsFromPrefs(prefs) {
  if (prefs?.preset === 'custom' && prefs.accent) {
    const a = prefs.accent;
    return {
      navBg: a,
      navBorder: `color-mix(in srgb, ${a} 75%, black)`,
      appBg: `linear-gradient(135deg, color-mix(in srgb, ${a} 10%, white) 0%, #ffffff 55%, color-mix(in srgb, ${a} 16%, white) 100%)`,
      solid: `color-mix(in srgb, ${a} 6%, white)`,
    };
  }
  return THEMES[prefs?.preset] || THEMES.classic;
}

export function applyTheme(prefs) {
  const v = themeVarsFromPrefs(prefs);
  const root = document.documentElement;
  root.style.setProperty('--nav-bg', v.navBg);
  root.style.setProperty('--nav-border', v.navBorder);
  root.style.setProperty('--app-bg', v.appBg);
  root.style.setProperty('--app-bg-solid', v.solid);
  try { localStorage.setItem('dawal_theme', JSON.stringify(prefs || { preset: 'classic' })); } catch { /* private mode */ }
}

export function getSavedTheme() {
  try {
    const raw = localStorage.getItem('dawal_theme');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function loadSavedTheme() {
  const prefs = getSavedTheme();
  if (prefs) applyTheme(prefs);
}
